import { LayoutActionKey } from "../../../actions/ActionKeys";
import { LayoutAction } from "../../../actions/layout";

export const tabs = (
  state: string[] = ["editor"],
  action: LayoutAction
): string[] => {
  switch (action.type) {
    case LayoutActionKey.ADD_TAB:
      return state.includes(action.payload.tab.id)
        ? state
        : [...state, action.payload.tab.id];
    case LayoutActionKey.CLOSE_TAB:
      return [...state].filter(id => id !== action.payload.id);
    default:
      return state;
  }
};
